<template>
    <Dialog
        :modal="true"
        v-model:visible="abrir_modal"
        :closable="true"
        class="col-12 sm:col-12 md:col-6"
    >
        <div class="solicitud-paso-5-ayuda">
            <div class="solicitud-paso-5-ayuda-imagen">
                <img src="/images/car.png" />
            </div>
            <div class="solicitud-paso-5-ayuda-texto">
                Necesitamos esta información para enviarte la autorización con
                los detalles de tu solicitud y para que recibas los datos para
                realizar el pago correspondiente.
            </div>
        </div>
        <template #footer>
            <Button
                label="¡Listo!"
                icon="fas fa-check"
                class="p-button-info p-mr-2 p-button-rounded"
                v-tooltip.bottom="'¡Listo!'"
                @click="abrir_modal = false"
            />
        </template>
    </Dialog>
</template>

<script>
export default {
    name: "solicitud-paso-5-ayuda-component",
    props: {},
    data() {
        return {
            abrir_modal: false,
        };
    },
    methods: {},
    validations() {},
    mounted() {
        this.emitter.on("solicitud-paso-5-ayuda", () => {
            this.abrir_modal = true;
        });
    },
};
</script>

<style>
.solicitud-paso-5-ayuda {
    padding: 0 15px;
    display: flex;
}

.solicitud-paso-5-ayuda-imagen {
    width: 25%;
}

.solicitud-paso-5-ayuda-imagen img {
    padding: 10px;
}

.solicitud-paso-5-ayuda-texto {
    padding: 0 20px;
    width: 75%;
    font-weight: bold;
    font-size: 25px;
}

.icono-mas {
    font-size: 40px !important;
    color: #689f38;
}

.icono-menos {
    font-size: 40px !important;
    color: #d32f2f;
}

@media screen and (max-width: 520px) {
    .solicitud-paso-5-ayuda {
        flex-wrap: wrap;
    }
    .solicitud-paso-5-ayuda-imagen,
    .solicitud-paso-5-ayuda-texto {
        width: 100%;
    }

    .solicitud-paso-5-ayuda-imagen img {
        margin: 0 auto;
    }
}
</style>
